<template>
  <section :key="key" class="lector pt-12">
    <div class="lector__info mt-16 px-md-10 px-4">
      <v-row class="align-center">
        <v-col cols="12" class="col-sm-9">
          <div class="lector__info-title">
            <p class="my-0">{{ lectorsData.bioLabel }}</p>
            <h2 class="mt-1">{{ lector.firstName }} {{ lector.lastName }}</h2>
          </div>
          <v-img
            width="100vw"
            height="100vw"
            :src="
              lector.img
                ? require(`@/assets/img/lectures2025/${lector.img}`)
                : ''
            "
            v-if="$vuetify.breakpoint.smAndDown"
            position="top center"
          >
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular
                  v-if="lector.img"
                  indeterminate
                  color="#FFA903"
                />
              </v-row>
            </template>
            <v-btn
              tile
              color="#fff"
              elevation="0"
              width="150"
              height="50"
              class="cancelButton"
              to="/lectors"
            >
              <v-icon>mdi-chevron-left</v-icon>
              {{ lectorsData.title }}
            </v-btn>
          </v-img>
          <div class="lector__info-about mt-7">
            <p v-html="lector.about" class="my-0"></p>
          </div>
          <div class="divider my-8"></div>
        </v-col>
        <v-col cols="3" class="hidden-sm-and-down">
          <v-img
            :src="
              lector.img
                ? require(`@/assets/img/lectures2025/${lector.img}`)
                : ''
            "
            class="lector__info-img"
            width="15rem"
            height="18rem"
            position="top center"
          >
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular
                  v-if="lector.img"
                  indeterminate
                  color="#FFA903"
                />
              </v-row>
            </template>
          </v-img>
        </v-col>
      </v-row>
    </div>
    <div v-if="lector.theme" class="theme mt-5 px-md-10 px-4">
      <div class="theme__title">
        <p class="my-0">{{ lectorsData.topicsLabel }}</p>
        <h2 class="mt-2">{{ lector.theme }}</h2>
      </div>
      <p v-html="lector.description" class="theme__desc mt-8"></p>
    </div>

    <div v-if="lector.interview" class="theme mt-5 px-md-10 px-4">
      <div class="theme__title">
        <p class="my-0">{{ lectorsData.interviewLabel }}</p>
        <h2 class="mt-2">{{ lector.interview }}</h2>
      </div>
      <p v-html="lector.description" class="theme__desc mt-8"></p>
    </div>

    <div v-if="lector.discussionTheme" class="theme mt-5 px-md-10 px-4">
      <div class="theme__title">
        <p class="my-0">{{ lectorsData.discussionClubLabel }}</p>
        <h2 class="mt-2">{{ lector.discussionTheme }}</h2>
      </div>
      <p v-html="lector.description" class="theme__desc mt-8"></p>
    </div>
    <div
      v-if="$vuetify.breakpoint.mdAndUp && similarTopics.length > 0"
      class="similar mt-8 pt-15 px-md-10 px-4"
    >
      <h3 class="mb-8">{{ lectorsData.similarTopicsLabel }}</h3>
      <v-row>
        <v-col cols="3" v-for="item in similarTopics" :key="item.id">
          <lector :person="item"></lector>
        </v-col>
      </v-row>
    </div>
  </section>
</template>

<script>
import lector from "@/components/lector";

export default {
  name: "Lector",
  components: {
    lector
  },
  computed: {
    lectorsData() {
      return this.$t("lectors");
    },
    lector() {
      const id = this.$route.params.id;
      return (
        this.lectorsData.lectors?.find(
          lectorItem => id === lectorItem.id.toString()
        ) ?? null
      );
    },
    similarTopics() {
      return this.$t("lectors").lectors?.slice(0, 4) ?? [];
    }
  },
  data() {
    return {
      key: this.$route.path
    };
  },
  mounted() {
    if (this.lector == null) {
      this.$router.push("/lector-not-found");
    }
  }
  // mounted() {
  //   const id = this.$route.params.id;
  //   const currentLecturer = this.$store.getters.getLectorById(+id);
  //   if (currentLecturer) {
  //     this.lector = {
  //       ...currentLecturer,
  //       img: require(`@/assets/img/lectures2025/${currentLecturer.img}`)
  //     };
  //   } else {
  //     this.$router.push("/not-found");
  //   }
  // },
  // async mounted() {
  //   const lector = await fetchLectorById(this.id);
  //   this.lector = { ...lector, img: `${API_URL}/${lector.img}` };
  // },
  // async beforeUpdate() {
  //   const lector = await fetchLectorById(this.id);
  //   this.lector = { ...lector, img: `${API_URL}/${lector.img}` };
  // }
};
</script>

<style lang="sass" scoped>
@import "./src/assets/style/vars"

@media (max-width: 600px)
  .theme__desc
    width: 100% !important
    font-size: 16px !important

.lector
  min-height: 90vh
  color: $dark
  &__info
    &-title
      p
        color: $medium
    &-about
      width: 95%
      p
        font-size: 16px !important

.theme
  &__title
    p
      color: $medium
  &__desc
    width: 75%

.similar
  background-color: #F9F7FC

.cancelButton
  color: #A0A0AE
  font-weight: 700
  font-size: 16px
  font-family: 'Roboto', sans-serif !important
  text-transform: unset
  display: flex
  align-items: center
  position: absolute
  left: 0
  bottom: 0
</style>
